import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import UserList from './pages/User/List';
import UserEdit from './pages/User/Edit';
import Entities from './pages/Entities';
import Login from './pages/Login';
import Logout from './pages/Logout';
import TestCombo from './pages/TestCombo';
import Fvt from './pages/fvt';
import QueryList from './pages/Query/List';
import QueryEdit from './pages/Query/Edit';
import EditClause from './pages/Query/EditClause';
import EditColdef from './pages/Query/EditColdef';
import DynamicChartLayout from './pages/DynamicChartLayout';
import PDFCreator from './pages/PDF/create';
import WillItBend from './pages/WillItBend';
import PageManagerList from './pages/PageManager/List';
import PageManagerEdit from './pages/PageManager/Edit';
import Media from './pages/Media';
import AccountDetails from './pages/AccountDetails';


const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/login" element={<Login />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/user" element={<UserList />} />
                <Route path="/user/create" element={<UserEdit />} />
                <Route path="/user/edit/:id" element={<UserEdit />} />
                <Route path="/pages" element={<PageManagerList />} />
                <Route path="/pages/edit/:id" element={<PageManagerEdit />} />
                <Route path="entities" element={<Entities />} />
                <Route path="testCombo" element={<TestCombo />} />
                <Route path="fvt" element={<Fvt />} />
                <Route path="/query" element={<QueryList />} />
                <Route path="/query/create" element={<QueryEdit />} />
                <Route path="/query/edit/:id" element={<QueryEdit />} />
                <Route path="/query/clauses/:app/:category" element={<EditClause />} />
                <Route path="/query/coldef/:queryId" element={<EditColdef />} />
                <Route path="/chart/page/:id" element={<DynamicChartLayout />} />
                <Route path="/pdf/create" element={<PDFCreator />} />
                <Route path="/media" element={<Media />} />
                <Route path="/account" element={<AccountDetails />} />
                <Route path="/compte" element={<AccountDetails />} />
                <Route path="/willitbend" element={<WillItBend />} />
            </Routes>
        </Router>
    );
};

export default App;
